import { Component, inject, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';
import { DataSharingService } from '../../../services/data-sharing.service';

@Component({
    selector: 'aira-string-list',
    templateUrl: './aira-string-list.component.html',
    styleUrl: './aira-string-list.component.css',
    standalone: false
})
export class AiraStringListComponent {
  @Input() label = '';
  @Input() data: any;
  @Input() headerKeyName = '';
  @Input() contentKeyName = '';
  @Input() previewOnly: boolean = false;

  dataStore = inject(DataSharingService);

  ngOnInit() {
    if (this.previewOnly) {
      this.data = this.replaceDataWithDummyData();
    }
  }

  replaceDataWithDummyData(): void {
    const dummyData = this.data.map((obj, index) => {
      return {
        [this.headerKeyName]: `${magicPreviewDummyData.names[index]}`,
        [this.contentKeyName]:
          `${magicPreviewDummyData.managementRoles[index]}`,
      };
    });

    return dummyData;
  }
}
